<template>
    <div>
        <el-row class="search-add" :gutter="10">
            <el-col :span="4">
                <el-input placeholder="固件名" v-model="searchName" clearable></el-input>
            </el-col>
            <el-col :span="4">
                <el-select placeholder="固件类型" v-model="searchType" clearable style="width: 100%">
                    <el-option label="app" value="app"></el-option>
                    <el-option label="mcu" value="mcu"></el-option>
                    <el-option label="gps" value="gps"></el-option>
                </el-select>
            </el-col>
            <el-col :span="4">
                <el-input placeholder="版本号" v-model="searchVersion" clearable></el-input>
            </el-col>
            <el-col :span="10">
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-col>
            <el-col :span="2">
                <router-link to="./add">
                    <el-button type="success">新增</el-button>
                </router-link>
            </el-col>
        </el-row>

        <el-table :data="data" border stripe style="width: 100%">
            <el-table-column prop="name" label="固件名" min-width="200">
            </el-table-column>
            <el-table-column prop="type" label="固件类型" width="120">
                <template slot-scope="scope">
                    <el-tag>{{ scope.row.type }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="version" label="版本号" width="120">
            </el-table-column>
            <el-table-column prop="fileName" label="文件名" min-width="200">
            </el-table-column>
            <el-table-column prop="romModel" label="固件名称" width="150">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="210">
                <template slot-scope="scope">
                    <el-button @click="Edit(scope.$index)" type="text" size="small">编辑</el-button>
                    <el-button @click="Delete(scope.$index)" type="text" size="small">删除</el-button>
                    <el-button @click="Level(scope.$index)" type="text" size="small">设备升级</el-button>
                    <el-button @click="lishi(scope.$index)" type="text" size="small">升级历史</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
    export default {
        name: 'admin',
        data() {
            return {
                searchName: '',
                searchType: '',
                searchVersion: '',
                data: [],
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                },
                checkArray:[]//check选中
            }
        },
        async created() {
            // if (this.$route.params.id) {
            //     this.deviceId = this.$route.params.id !== ':id' ? this.$route.params.id : '';
            //     this.tableHeight = document.documentElement.clientHeight - 200 + "px";
            // } else {
            //     this.$router.go(-1);
            // }
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    pageNum: this.pagin.pageNum,
                    pageSize: this.pagin.pageSize,
                }
                if(this.searchName.trim() != '') {
                    params.name = this.searchName;
                }
                if(this.searchType) {
                    params.type = this.searchType;
                }
                if(this.searchVersion.trim() != '') {
                    params.version = this.searchVersion;
                }
                this.$http.post('/manage/firmH06/list', params).then(results => {
                    this.data = results['data']['data']['records'];
                    this.pagin.total = results['data']['data']['total'];
                });
            },
            Edit(index) {
                this.$store.commit('setEditInfo',this.data[index]);
                // this.$router.push('/edit/'+this.data[index].id);
                this.$router.push('/equipment/vehicleGPS/otaUpgrade/edit/'+this.data[index].id);

            },
            Delete(index) {
                //单删
                if(confirm('确认要删除吗？')) {
                    let ID = this.data[index].id;
                    this.$http.post('/manage/firmH06/del',{firmH06Id:ID}).then(() => {
                        this.data.splice(index, 1);
                    })
                }
            },
            Level(index) {
                this.$router.push('./upgrade/'+this.data[index].id);
            },
            lishi(index) {
                console.log('/equipment/vehicleGPS/otaUpgrade/list/'+this.data[index].id);
                this.$router.push('/equipment/vehicleGPS/otaUpgrade/list/'+this.data[index].id);
            }
        },
        components: { Pagination }
    }
</script>